import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getAccAccount, resetAccAccountState } from "../../../../store/accAccount/action";
import { resetBranchState, getBranch } from "../../../../store/branch/action";
import { resetAccTransState, getAccTrans as onGetAccTranss } from "../../../../store/accTrans/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../../Components/Common/ExportDoc";
import handleValidDate from "../../../../helpers/utils/handleValidDate";

const ReportTransactionTechical = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const [accTransDoc, setAccTransDoc] = useState([]);
  const dispatch = useDispatch();

  const { accTranss, isAccTransCreated, isAccTransSuccess, loading, error, branches, branchLoading, accAccounts, accAccountLoading } = useSelector((state) => ({
    accTranss: state.AccTrans.accTranss,
    isAccTransCreated: state.AccTrans.isAccTransCreated,
    isAccTransSuccess: state.AccTrans.isAccTransSuccess,
    loading: state.AccTrans.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
    error: state.AccTrans.error,
  }));

  const [accTransList, setAccTransList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [filterDate, setFilterDate] = useState();
  const [filterAcc, setFilterAcc] = useState();
  const [searchBranch, setSearchBranch] = useState("");

  const [accountingList, setAccountingList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetAccTransState());
      setIsSearch(true);

      const obj = JSON.parse(localStorage.getItem("authUser"));
      setUserType(obj?.data?.userType);
      setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);

      dispatch(onGetAccTranss({ accId: 433, branchId: 1, status: 2 }));
      handleGetAccAccount(obj.data.companyId);
      handleGetBranch(obj.data.companyId);
    }
  }, [dispatch, isSearch]);

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [{ label: "Pilih Akun", value: null }];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        const categoryCode = item?.acc_account_category?.code;
        var obj = { label: code + " " + name, value: id, category: categoryCode };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [{ label: "Pilih Cabang", value: null }];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(accTranss)) {
      let arr = [];
      accTranss
        .sort(function (a, b) {
          return new Date(a.transactionat) - new Date(b.transactionat);
        })
        .forEach((item, idx) => {
          let temp_saldo = arr[idx - 1] && arr[idx - 1].saldo ? arr[idx - 1].saldo : 0;
          let debit = item.at_detail.length ? item.at_detail[0].debit : 0;
          let credit = item.at_detail.length ? item.at_detail[0].credit : 0;
          if (debit > 0) {
            temp_saldo = parseFloat(temp_saldo) + parseFloat(debit);
          }
          if (credit > 0) {
            temp_saldo = parseFloat(temp_saldo) - parseFloat(credit);
          }
          item.nomor = "";
          item.debit = debit;
          item.credit = credit;
          item.saldo = temp_saldo;
          item.tag = item.at_tag?.name;
          item.createdby = item.at_createdby?.name;
          arr.push(item);
        });
      setAccTransList(arr);
    }
  }, [accTranss]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Nomor",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "createdby",
        label: "PIC",
        isSelected: true,
        data: [],
      },
      {
        id: "debit",
        label: "debit",
        isSelected: true,
        data: [],
      },
      {
        id: "credit",
        label: "credit",
        isSelected: true,
        data: [],
      },
      {
        id: "saldo",
        label: "Saldo",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tags",
        isSelected: true,
        data: [],
      },
    ];

    if (accTransList.length > 0) {
      accTransList.forEach((accTrans) => {
        if (accTrans.isChecked) {
          Object.entries(accTrans).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              doc.data.push(value ?? "-");
            }
          });
        }
      });
    }

    setAccTransDoc(dataDoc);
  }, [accTransList]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = accTransList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAccTransList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = accTransList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setAccTransList(updatedData);
                }} />
            </div>
          );
        },
      },
      {
        id: "transactionat",
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return <div>{handleValidDate(data.transactionat, "DD/MM/YYYY")}</div>;
        },
      },
      {
        id: "transaction",
        Header: "Transaksi",
        accessor: "code",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return <div>{data.code}</div>;
        },
      },
      {
        id: "number",
        Header: "Nomor",
        accessor: "number",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return <div>{data.nomor}</div>;
        },
      },
      {
        id: "description",
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div className="text-break" style={{ width: "200px" }}>
              {data.description}
            </div>
          );
        },
      },
      {
        id: "pic",
        Header: "PIC",
        accessor: "createdby",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return <div>{data.createdby}</div>;
        },
      },
      {
        id: "debit",
        Header: "Debit",
        accessor: "debit",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return <div>{currencyFormat(data.debit ?? 0)}</div>;
        },
      },
      {
        id: "credit",
        Header: "Kredit",
        accessor: "credit",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return <div>{currencyFormat(data.credit ?? 0)}</div>;
        },
      },
      {
        id: "amount",
        Header: "Saldo",
        accessor: "amount",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return <div>{currencyFormat(data.saldo ?? 0)}</div>;
        },
      },
      {
        id: "at_tag",
        Header: "Tags",
        accessor: "tag",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div className="text-break" style={{ width: "200px" }}>
              {data.tag}
            </div>
          );
        },
      },
    ],
    [accTransList, isCheckAll]
  );


  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = accTransList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAccTransList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => accTransList, [accTransList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 1000000,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: 2,
      branchId: searchBranch.value ?? "",
      accId: filterAcc?.value ?? "",
    };
    dispatch(onGetAccTranss(param));
  }

  document.title = "Laporan Saldo Akun Keuangan | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accTransList} />
      <Container fluid>
        <BreadCrumb title="Laporan Saldo Akun Keuangan" pageTitle="Laporan Keuangan" />
        <Row>
          <Col lg={12}>
            <Card id="accTransList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Laporan Saldo Akun Keuangan &nbsp;
                    {isLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <ExportDoc data={accTransDoc} />
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                            gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}/>
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}/>
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <Select
                              name="searchBranch"
                              value={searchBranch}
                              placeholder="Filter Proyek"
                              onChange={(e) => {
                                setSearchBranch(e);
                              }}
                              options={branchList}></Select>
                          </Col>
                          <Col sm={3}>
                            <Select
                              name="searchAcc"
                              value={filterAcc}
                              placeholder="Filter Akun"
                              onChange={(e) => {
                                setFilterAcc(e);
                              }}
                              options={accountingList}></Select>
                          </Col>

                          <Col sm={1}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr className={""} key={index} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">
                      {rows.length} Data
                    </Col>
                  </Row>
                </div>
                
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReportTransactionTechical;
